import Button from '@src/components/button/Button';
import styles from './NavLayout.module.scss';
import { useGenerateParentLinkForUserMutation } from '@src/api/graphql-codegen';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import { Tooltip } from 'antd';
import IconOutline from 'src/assets/icons/new-outline-info.svg?react';
import { IconInfo, IconShare } from '@src/constants';
import { useCallback } from 'react';
import { useToast } from '@src/hooks';
import { logger } from '../../../utils/logger';


type Props = {
  isUser: boolean;
}

function CaregiverNavLayout(props: Props) {

  const { isUser } = props;

  const { successToast } = useToast();
  
  const [generateParentLinkForUser, { loading: generatingParentAppLink }] = useGenerateParentLinkForUserMutation();

    const generateAndCopyParentAppLink = useCallback(async () => {
      try {
        const result = await generateParentLinkForUser({ variables: { input: { uniqueName: '' } } });
        if (result.data?.generateParentLinkForUser?.id) {
          await navigator.clipboard.writeText(`${window.location.protocol}//${window.location.host}/parent/login?id=${result.data?.generateParentLinkForUser?.id}`)
          successToast('Link Copied Successfully!');
        }
      } catch (e) {
        logger.info(e)
      }
    }, [successToast, generateParentLinkForUser]);

  return (
    <>
      <div id={"navMenuBar"} className={styles.navView}>
        <div className={styles.itemWrapper}>
          <div className={[styles.listItem, styles.selItem].join(' ')}>
            <div className={[styles.listTitle, styles.selItemTitle].join(' ')}>
            {'Caregiver Resources'}
            </div>
          </div>
        </div>
        {isUser && <div className={styles.shareView}>
          <Button label='Share' isLoading={generatingParentAppLink} disabled={generatingParentAppLink} className={styles.shareButton} 
            leftIcon={<LordIcon src={IconShare} isHover={true} colors={{primary: '#FFFFFF', secondary: '#FFFFFF'}} target='.TabLayout_shareButton__fIDYe' size={30}/>} onClick={generateAndCopyParentAppLink} />
          <Tooltip
            placement='leftTop'
            title={
              <div className={styles.cardBack}>
                <IconOutline className={styles.hoverIcon} width={46}/>
                <div className={styles.hoverCardText}>
                  <div className={styles.span1}>Click the “Share” button to provide access to parents and caregivers. This will copy a link which you can share via email.</div>
                  <div className={styles.span2}><strong>Note. </strong>This link does not provide access to the main Open Parachute Dashboard and classroom lessons. It will only provide access to the Caregiver Resources.</div>
                </div>
              </div>
            }
            overlayStyle={{maxWidth: '400px'}}
            showArrow={false}
            color='#FFFFFF'>
            <div className={styles.infoIcon} >
              <LordIcon size={30} src={IconInfo} isHover={true} colors={{primary: '#FFB073', secondary: '#FFB073'}}/>
            </div>
          </Tooltip>
        </div>}
      </div>
    </>
  );
}

export default CaregiverNavLayout;
